var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-icon-container"},[_c('v-icon',{staticClass:"close-icon",class:_vm.iconclass,style:(_vm.styles),attrs:{"data-cy":_vm.dataCy},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }